<div class="flxClmn">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container">
			<span class="page-title">Permission Management</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Permissions for admins, reviewers and global reviewers</span>
		</div>
	</div>

	<div class="page-inner-content-holder no-scroll flxClmn pt-0">
		<!--CC: tabs - taken from email-flow-tabs.component.html-->
		<div class="md-tabs" [ngStyle]="{'--md-tabs-width': tabWidth + 'px'}" style="flex-shrink: 0; margin-bottom: 15px;">
			<ng-container *ngFor="let tab of dic.CONSTANTS.userPermissionsPageTabs | keyvalue: gs.returnZero">
				<!--CC: multi tenant tab is partner-only - same guard as the Partners page (userPermissionService: partner plan + admin/sub-admin or partner reviewer)-->
				<div *ngIf="tab.value !== dic.CONSTANTS.userPermissionsPageTabs.multiTenant || (gs.userInfo?.plan?.customer_id && (gs.userInfo?.user_role === dic.CONSTANTS.userRole.admin || gs.userInfo?.user_role === dic.CONSTANTS.userRole.subAdmin || gs.userInfo?.isPartnerReviewer))"
					 [ngClass]="{'selected' : gs.getTabName() === tab.value}"
					 [routerLink]="tab.value" queryParamsHandling="preserve">
					<input type="radio" name="tabs" id="{{tab.key}}Toggle" [checked]="gs.getTabName() === tab.value">
					<label for="{{tab.key}}Toggle">{{tab.value | camelCaseToTitleCase}}</label>
				</div>
			</ng-container>

			<div class="slide" [ngStyle]="{'left' : tabWidth * _.values(dic.CONSTANTS.userPermissionsPageTabs).indexOf(gs.getTabName()) + 'px' || 0}"></div>
		</div>

		<router-outlet></router-outlet>
	</div>
</div>
